// @ts-nocheck
import { apply, call } from 'redux-saga/effects';
import { handleResponseChat } from './handleResponseChat';
import { handleError } from '../../../handleError';

export function* handleResponse({ payload }) {
  try {
    const data = yield apply(JSON, JSON.parse, [payload.message]);
    if (data.app === 'chat') {
      yield call(handleResponseChat, data);
    }
  } catch (e) {
    yield handleError(e);
  }
}
